import { get } from 'lodash/object';
import captureException from '%app/js/common/services/captureException';
import hallClient from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/service/HallClient';
import HallValidationError from '%paysera_seat_selection/js/seatSelection/redux/component/workflow/error/HallValidationError';

class HallManager {
    async saveHall(hallData) {
        try {
            let seatingData = null;
            if (hallData.id === null) {
                const response = await hallClient.createHall(hallData);
                seatingData = response.data;
            } else {
                const response = await hallClient.updateHall(hallData.hash, hallData);
                seatingData = response.data;
            }
            return seatingData;
        } catch (error) {
            if (get(error, 'response.data.error_properties') !== undefined) {
                throw new HallValidationError(error.response.data);
            }
            captureException(error);
            throw error;
        }
    }

    async getHall(hash) {
        return (await hallClient.getHall(hash)).data;
    }
}

export default new HallManager();
